import type { CarDetailsImage } from '@autobid/ui/types/components/CarDetails'

export function getDetailsImageAlt(img: CarDetailsImage, locale: string) {
  let desc
    = img.description.dedicated?.[locale] ?? img.description.categoryLabel

  if (img.description.defects?.length) {
    desc += ` - ${img.description.defects.map(el => el.name).join(', ')}`
  }

  return desc
}
